
















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BASE_URL } from "@/store/modules/api";

// Enums/Data
import { DataModules } from "@/store/modules/data";

@Component
export default class FileUploadField extends Vue {
  @Prop({ required: true })
  public value;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public fieldId;

  @Prop({ required: true })
  public fieldName!: string;

  @Prop({ default: () => ({}) })
  public existingFile!: object;

  @Prop({ default: false })
  public allowPreview!: boolean;

  @Prop({ required: true })
  public fileTypes!: string[];

  @Prop({ default: false })
  public isUploading;

  @Prop({ default: 0 })
  public progress;

  @Prop({ default: "file-alt" })
  public icon!: string;

  public file = {};

  public created() {
    this.setFile();
  }

  public setFile() {
    if (this.$_.isEmpty(this.existingFile)) {
      return;
    }
    this.file = this.$_.cloneDeep(this.existingFile);
  }

  public get imageHash() {
    return this.allowPreview ? this.value : null;
  }

  public set imageHash(value) {
    if (!this.allowPreview) {
      return;
    }
    this.$emit("input", value);
  }

  public get imageSrc() {
    return !this.$_.isEmpty(this.file) && this.$_.get(this.file, "fileObj.type")
      ? URL.createObjectURL(this.$_.get(this.file, "fileObj"))
      : this.imageHash
      ? this.imagePathFromHash
      : "";
  }

  public get imagePathFromHash() {
    return `${BASE_URL}api/images/${this.imageHash}/download`;
  }

  public preview() {
    this.$store.dispatch(`data/${DataModules.IMAGES}/openImagePreviewModal`, {
      props: {
        imagePath: `${this.imagePathFromHash}?size=original`
      }
    });
  }

  @Watch("file")
  public onFileChange() {
    if (this.$_.get(this.file, "exists", true)) {
      this.$emit("input", 0);
      this.$emit("fileAdded", this.file, this.fieldId);
    } else {
      this.$emit("input", null);
      this.$emit("fileDeleted", this.fieldId);
    }
  }
}
